/**
 * AI Generation Endpoints Configuration
 * Centralized configuration for AI image and text generation endpoints
 */

export interface AIEndpointConfig {
  baseUrl: string;
  imageEndpoint: string;
  textEndpoint: string;
}

/**
 * Get AI endpoint configuration from environment variables
 * All values must be provided via environment variables
 */
export const getAIEndpointConfig = (): AIEndpointConfig => {
  return {
    baseUrl: import.meta.env.VITE_AI_BASE_URL,
    imageEndpoint: import.meta.env.VITE_AI_IMAGE_ENDPOINT,
    textEndpoint: import.meta.env.VITE_AI_TEXT_ENDPOINT
  };
};

/**
 * Build complete URL for image generation
 */
export const buildImageGenerationUrl = (prompt: string, timestamp?: number): { url: string; base: string } => {
  const config = getAIEndpointConfig();
  const ts = timestamp || Date.now();
  
  return {
    url: `${config.imageEndpoint}?prompt=${encodeURIComponent(prompt.trim())}&_t=${ts}`,
    base: config.baseUrl
  };
};

/**
 * Build complete URL for text generation
 */
export const buildTextGenerationUrl = (prompt: string, timestamp?: number): { url: string; base: string } => {
  const config = getAIEndpointConfig();
  const ts = timestamp || Date.now();
  
  return {
    url: `${config.textEndpoint}?prompt=${encodeURIComponent(prompt.trim())}&type=text&_t=${ts}`,
    base: config.baseUrl
  };
};
